import { Epic, ofType } from 'redux-observable';
import { EpicDependencies } from '@ui/store/rootEpic';
import * as actions from '../actions';
import { catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

export const loadManagers: Epic<any, any, any, EpicDependencies> = (
  action$,
  store,
  { userApi },
) =>
  action$.pipe(
    ofType(actions.MANAGERS_ACTIONS.REQUESTED),
    switchMap(() =>
      userApi.getManagers().pipe(
        switchMap(({ managers }) => of(actions.managersSucceeded(managers))),
        catchError(error => of(actions.managersFailed(error))),
      ),
    ),
  );



// WEBPACK FOOTER //
// ./src/scenes/Managers/services/epics/loadManagers.ts